module.exports = __webpack_public_path__ + "img/fail-1.eb64ed71.png";